import { Stack } from "@mui/material";
import styled from "styled-components";

export const StakeCard = styled(Stack)`
  padding: 20px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0px 0px 10px rgba(31, 237, 136, 0.33);
  border-radius: 16px;
  background: #121212;
  margin: 0px 5px 5px 0px;
`;

// export const DashboardCardTokenStatsTable = styled(Stack)`
//   padding: 20px;
//   border: 1px solid rgba(255, 255, 255, 0.2);
//   box-shadow: 0px 0px 10px rgba(31, 237, 136, 0.33);
//   border-radius: 16px;
//   background: #121212;
//   margin: 40px 0px 0px 0px;
//   @media (max-width: 1100px) {
//     display: none;
//   }
// `;

export const StakeCardDivider = styled.div`
  height: 1px;

  background: rgba(255, 255, 255, 0.2);
  border-radius: 0px;
  transform: matrix(1, 0, 0, -1, 0, 0);
   
  /* Inside auto layout */

  flex: none;
  flex-grow: 0;
  margin: 0px 0px 12px 0px;
`;
